import { applyDefaultDate } from '../utils/date-utils';
import { useUtils, useDefaultDates } from './useUtils';
import {
  BaseDateValidationProps,
} from '../models/validation';
import { DefaultizedProps } from '../models/helpers';
import { PickerValidDate } from '../../models';

export interface UseDefaultizedDateFieldBaseProps<TDate extends PickerValidDate>
  extends BaseDateValidationProps<TDate> {
  format?: string;
}

export const useDefaultizedDateField = <
  TDate extends PickerValidDate,
  TKnownProps extends UseDefaultizedDateFieldBaseProps<TDate>,
  TAllProps extends {},
>(
  props: TKnownProps & TAllProps,
): TAllProps & DefaultizedProps<TKnownProps, keyof UseDefaultizedDateFieldBaseProps<any>> => {
  const utils = useUtils<TDate>();
  const defaultDates = useDefaultDates<TDate>();

  return {
    ...props,
    disablePast: props.disablePast ?? false,
    disableFuture: props.disableFuture ?? false,
    format: props.format ?? utils.formats.keyboardDate,
    minDate: applyDefaultDate(utils, props.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, props.maxDate, defaultDates.maxDate),
  };
};
